import { render, staticRenderFns } from "./SuperAdmin.vue?vue&type=template&id=d4bcd908&scoped=true&"
import script from "./SuperAdmin.vue?vue&type=script&lang=js&"
export * from "./SuperAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdmin.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SuperAdmin.vue?vue&type=style&index=1&id=d4bcd908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bcd908",
  null
  
)

export default component.exports